module.exports = __webpack_public_path__ + "img/LSSleeve.4590d8cc.jpg";